module.exports = __webpack_public_path__ + "img/audio-mark11.a44e0f18.png";